import { TicketArea, TicketStatus, TicketType } from '@/types/types';

// Status IDs come from the backend SupportCaseStatusEnum:
// Registered = 1, InProgress = 2, NextVersion = 3, ClosedRejected = 4,
// ClosedSolved = 5, AwaitingAnswerFromYou = 6
export const SUPPORT_CASE_STATUS = {
    Registered: 1,
    InProgress: 2,
    NextVersion: 3,
    ClosedRejected: 4,
    ClosedSolved: 5,
    AwaitingAnswerFromYou: 6,
} as const;

// Default "open" cases shown when the list loads: Registrerat, Under behandling, Väntar på svar.
// NextVersion / ClosedRejected / ClosedSolved are excluded from the default view.
export const ACTIVE_STATUS_IDS = new Set<number>([
    SUPPORT_CASE_STATUS.Registered,
    SUPPORT_CASE_STATUS.InProgress,
    SUPPORT_CASE_STATUS.AwaitingAnswerFromYou,
]);

export const toSelectOptions = (
    items: Array<TicketStatus | TicketType | TicketArea> | undefined
) =>
    (items ?? [])
        .filter((item) => item.Id != null)
        .map((item) => ({
            value: item.Id as number,
            label: item.Name ?? `#${item.Id}`,
        }));

export const validateTicket = (values: { Title?: string; Description?: string }) => {
    const errors: { Title?: string; Description?: string } = {};
    if (!values.Title?.trim()) {
        errors.Title = 'Title is required';
    }
    if (!values.Description?.trim()) {
        errors.Description = 'Description is required';
    }
    return errors;
};
